import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { dealValueShow } from '@/shared/functions';
const initState = {
    totalMoney: 0,
    availableMoney: 0,
    frozenMoney: 0,
    title: '经销商信息',
    content: [
        [{ key: '', value: '' }],
    ],
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 加载详情 经销商信息  可用总额 */
        load(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { id, isSeller } = rootState.router.query;
                let content;
                let money;
                if (isSeller === 'true') {
                    content = yield this.sellerDetailData({ id });
                    money = yield this.sellerMoney({ userid: id });
                }
                else {
                    content = yield this.buyerDetailData({ id });
                    money = yield this.buyerMoney({ userid: id });
                }
                this.SET_STATE({
                    content,
                    totalMoney: dealValueShow(money.total),
                    availableMoney: dealValueShow(money.available),
                    frozenMoney: dealValueShow(money.frozen),
                });
            });
        },
        /**
         * @desc 卖家经销商详情
         */
        sellerDetailData(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                let result = [[{ key: '', value: '' }]];
                result = [
                    [{ key: '类型', value: '卖家' }],
                    [{ key: '经销商名称', value: '' },
                        { key: '联系手机号', value: '' },
                        { key: '联系人', value: '' }],
                    [{ key: '所在地', value: '' },
                        { key: '所在区域', value: '' },
                        { key: '集团', value: '' }],
                ];
                return Api.user.getSellerDealerDetail(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result[1][0].value = dealValueShow(data.shopName);
                    result[1][1].value = dealValueShow(data.mobile);
                    result[1][2].value = dealValueShow(data.userName);
                    result[2][0].value = dealValueShow(data.location);
                    result[2][1].value = dealValueShow(data.area);
                    result[2][2].value = dealValueShow(data.groupName);
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 卖家可用总额
         */
        sellerMoney(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                let result = { total: 0, available: 0, frozen: 0 };
                return Api.finance.singleSellerMoney(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result = {
                        total: dealValueShow(data.totalY),
                        available: dealValueShow(data.availableY),
                        frozen: dealValueShow(data.frozenY),
                    };
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 买家经销商详情
         */
        buyerDetailData(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                let result = [[{ key: '', value: '' }]];
                result = [
                    [{ key: '类型', value: '买家' }],
                    [{ key: '经销商名称(姓名)', value: '' },
                        { key: '联系手机号', value: '' },
                        { key: '身份证号码', value: '' }],
                ];
                return Api.user.getBuyerDealerDetail(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result[1][0].value = dealValueShow(data.realname);
                    result[1][1].value = dealValueShow(data.mobile);
                    result[1][2].value = dealValueShow(data.contactCode);
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 买家可用总额
         */
        buyerMoney(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                let result = { total: 0, available: 0, frozen: 0 };
                return Api.finance.singleBuyerMoney(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result = {
                        total: dealValueShow(data.totalY),
                        available: dealValueShow(data.availableY),
                        frozen: dealValueShow(data.frozenY),
                    };
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
    },
});
